import React from 'react';
import { Provider } from 'react-redux';
import Router from './router';
import Theme from './theme/Theme';
import { store } from './store';
import './i18n';

import './index.css';

function App() {
	return (
		<Provider store={store}>
			<Theme>
				<Router />
			</Theme>
		</Provider>
	);
}

export default App;
